<script setup>
import { computed, defineAsyncComponent, markRaw, ref, watch } from 'vue';

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    iconVariant: {
        type: String,
        default: 's',
    },
    size: {
        type: String,
    },
});

const IconComponent = ref(null);

const allIconPaths = {};

const requireContext = import.meta.webpackContext('!svg-vue3-loader!module/icon/files', {
    recursive: true,
    regExp: /\.svg$/,
});

requireContext.keys().forEach((key) => {
    allIconPaths[key] = () => Promise.resolve(requireContext(key));
});

const iconKeys = Object.keys(allIconPaths);

const allIcons = iconKeys.reduce((acc, cur) => ({
    ...acc,
    [cur]: markRaw(defineAsyncComponent(allIconPaths[cur])),
}), {});

const loadIcon = async (fileName) => {
    const componentKey = iconKeys.find((iconKey) => iconKey.split('/').at(-1) === fileName);
    IconComponent.value = allIcons[componentKey];
};

const iconFileName = computed(() => `${props.name}--${props.iconVariant}.svg`);

watch(iconFileName, loadIcon, { immediate: true });
</script>

<template>
    <component
        :is="IconComponent"
        :class="{
            [`m-icon--${size}`]: size,
        }"
        :data-qa="iconFileName"
        aria-hidden="true"
        class="m-icon"
    />
</template>

<style lang="scss">
@use "styles";
</style>
